import React, { forwardRef } from "react";
import { useDispatch } from "react-redux";
import {
  decreaseQuantity,
  remoteItemFromBasket,
} from "../features/basketSlice";
import "./CheckoutProduct.css";

const CheckoutProduct = forwardRef(
  ({ id, image, title, price, rating, quantity, originalPrice }, ref) => {
    const dispatch = useDispatch();
    const removeFromBasket = () => {
      dispatch(
        remoteItemFromBasket({
          id: id,
        })
      );
    };

    const lowerQuantity = () => {
      console.log(price);
      dispatch(
        decreaseQuantity({
          id: id,
          price: price,
          originalPrice: originalPrice,
        })
      );
    };

    return (
      <div ref={ref} className="checkoutProduct">
        <img className="checkoutProduct__image" src={image} />

        <div className="checkoutProduct__info">
          <div className="checkoutProduct__title">
            {title} [{quantity}]{" "}
            {quantity > 1 && (
              <button
                onClick={lowerQuantity}
                className="checkoutProductTitle__button"
              >
                -
              </button>
            )}
          </div>
          <div className="checkoutProduct__price">
            <small>$</small>
            <strong>{price}</strong>
          </div>
          <div className="checkoutProduct__rating">
            {Array(rating)
              .fill()
              .map((_, i) => (
                <div key={i}>🌟</div>
              ))}
          </div>
          <button onClick={removeFromBasket}>Remove from Basket</button>
        </div>
      </div>
    );
  }
);

export default CheckoutProduct;
